import Modal from "../../components/modals/Modal"
import React, { useState } from "react"
import useGqlGenerator from "./useGqlGenerator"
import CopyToClipboard from "react-copy-to-clipboard"
import { IoIosCopy } from 'react-icons/io';
import { toast } from 'react-toastify';
import LoadingIndicator from "../../components/LoadingIndicator";

interface AskAiModalProps {
  open: boolean,
  closeModal: () => void,
  id: string
}

const AskAiModal = ({
  open,
  closeModal,
  id
}: AskAiModalProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null)

  const [question, setQuestion] = useState('')

  const {
    fetchGql,
    content,
    loading
  } = useGqlGenerator()


  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (() => {
    setQuestion(inputRef.current?.value || '')
    fetchGql(id, inputRef.current?.value || '')
  })

  return <Modal
    className="w-[600px]"
    onClickBackdrop={closeModal}
    open={open}
  >
    <div className="max-h-[600px] min-h-[200px] flex flex-col">
      <div className="flex-1">
        <h3 className="text-2xl font-bold">Ask AI</h3>
        <div className="h-2" />
        <p className="text-sm text-gray-500">Ask AI a question and get an answer</p>


        <div className="max-h-[480px] overflow-auto">
          <div>
            {question}
          </div>
          {
            <div>
              {loading? <div className="w-full p-4 flex justify-center">
                <LoadingIndicator /> 
              </div>: content && <div className="p-4 bg-[#f5f5f5] my-6 relative">
                <div className="absolute right-[10px] top-[10px]">
                  <CopyToClipboard text={content}>
                    <button
                      onClick={() => {
                        toast.success('grahpQL query copied.', {
                          autoClose: 3000,
                        });
                      }}
                    >
                      <IoIosCopy size='1.2rem' className='opacity-60' />
                    </button>
                  </CopyToClipboard>
                </div>
                <pre>
                  {content}
                </pre>
              </div>}
            </div>
          }
        </div>
      </div>
      <div className="flex">
        <input ref={inputRef} type="text" placeholder="Type here" className="flex-1 input w-full max-w-sm border border-[#e3e3e3]	mr-2" />
        <button className="btn btn-primary" onClick={handleSubmit}>Ask AI</button>
      </div>
    </div>
  </Modal>
}

export default AskAiModal